export default __webpack_public_path__ + "static/media/9.568eb95c.png";